const Footer = () => {
  return (
    <footer>
      <div className="container text-center">
        <p>2024-25 Micro News Portal. All Rights Reserved.</p>

        <p>
          Created with ❤️ by <a href="https://github.com/hkgonebad/micro-news-portal">Hk</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
